import { PATHWAY } from "@/constants/testIds";
import { AI_NOTICE, CYBER_SAMPLE } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function CyberSample({ onGenerateReceipt }) {
  return (
    <section className="border-t hairline bg-[#0f0f0f]">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-24">
        <div
          data-testid={PATHWAY.cyberSampleCard}
          className="grid gap-10 border hairline p-8 md:grid-cols-[1.4fr_1fr] md:gap-16 md:p-12"
        >
          <div>
            <SectionEyebrow>First sample scenario</SectionEyebrow>
            <h3 className="mt-4 font-serif text-2xl leading-tight text-neutral-50 sm:text-3xl">
              {CYBER_SAMPLE.title}
            </h3>
            <p className="mt-6 text-[15px] leading-relaxed text-neutral-300">
              {CYBER_SAMPLE.blurb}
            </p>
            <div className="mt-6 inline-block border hairline px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
              {AI_NOTICE}
            </div>
          </div>

          <div className="flex flex-col justify-between border-l hairline pl-8 md:pl-12">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">
                Receipt fields generated
              </div>
              <ul className="mt-4 space-y-2 font-mono text-xs text-neutral-300">
                {[
                  "sponsor_theme",
                  "risk_scenario",
                  "actor_roles",
                  "evidence_requested",
                  "evidence_withheld",
                  "ai_use_boundary",
                  "authorised_decision",
                  "suggested_next_step",
                  "verification_state",
                ].map((f) => (
                  <li key={f}>— {f}</li>
                ))}
              </ul>
            </div>
            <button
              type="button"
              onClick={onGenerateReceipt}
              data-testid={PATHWAY.cyberSampleGenerate}
              className="mt-10 border border-amber-700 bg-amber-700 px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-white transition-colors hover:bg-amber-600"
            >
              Generate sample receipt
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
